export const workingday_sd_keys = {
    BEFORE: 'before',
    BETWEEN: 'between',
    AFTER_WORKING_HOURS: 'after_working_hours'
}
export const workingday_sd_keys_map = [
    workingday_sd_keys.BEFORE,
    workingday_sd_keys.BETWEEN,
    workingday_sd_keys.AFTER_WORKING_HOURS,
]

export const dayNames = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
};

export const autoFinalizeValues = {
    AUTO: 'true',
    NOT_AUTO: 'false',
    AUTO_ON_TIMER: 'timer',
};

export const dayNamesMap = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday,'
];

// Where a shipment lands once you know its carrier, its scans and its age. Derived by the backend from
// those three, never stored on the shipment. The values double as translation keys.
export const scan_statuses = {
    SCANNED: 'scanstatus_scanned',
    NO_SCAN: 'scanstatus_no_scan',
    JUST_SHIPPED: 'scanstatus_just_shipped',
    NO_SCAN_INFO: 'scanstatus_no_info'
};

export const return_type = {
    DEFAULT: 'default',
    BOL: 'bol',
    RETURNPORTAL: 'returnportal',
    RETURNLESS: 'returnless',
    UNANNOUNCED:'unannounced'
};

//pickingprocesstype
export const pickingprocesstype = {
  //  AUTO: 'auto',
    ONLY_CART: 'only_cart',
    CART_LOCATION_CRATE:  'cart_location_crate',
    CART_LOCATION:  'cart_location',
    CART_CRATE:  'cart_crate',
    PRODUCT_LIST: 'product_list',
    // CART_ORDERLABEL:  'cart_orderlabel',
    // PALLET_ORDERLABEL:  'pallet_orderlabel',
}

export const photo_source = {
    FULFILMENT: 'fulfilment',
    CONSUMER: 'consumer'
}


export const general_states = {
    ACTION_REQUIRED_CUSTOMER: 'action_required_customer',
    ACTION_REQUIRED_WAREHOUSE: 'action_required_warehouse',
    ACTIVE: 'active',
    RECEIVED:'received',
    ANNOUNCED: 'announced',
    APPROVED: 'approved',
    AVAILABLE: 'available',
    AWAITING_APPROVAL: 'awaiting_approval',
    BACKORDERED: 'backordered',
    BLOCKED: 'blocked',
    CANCELLED: 'cancelled',
    COMPLETED: 'completed',
    CONCEPT: 'concept',
    CONFIRMED: 'confirmed',
    DECLINED: 'declined',
    DELETED: 'deleted',
    ECHECK: 'echeck',
    EXPORTED: 'exported',
    FAILED: 'failed',
    FINALIZED: 'finalized',
    FULLYPICKED: 'fullypicked',
    FULLYRECEIVED: 'fullyreceived',
    IGNORED: 'ignored',
    IN_PROGRESS: 'in_progress',
    IMPORTED: 'imported',
    INACTIVE: 'inactive',
    JOKER: 'joker',
    LINKED: 'linked',
    MAINTENANCE: 'maintenance',
    NOTRECEIVED: 'notreceived',
    OCCUPIED: 'occupied',
    OPEN: 'open',
    OPENED: 'opened',
    PAID: 'paid',
    PARTLYRECEIVED: 'partlyreceived',
    PICKING_IN_PROGRESS: 'picking_in_progress',
    PICKED: 'picked',
    RECEIVEDWITHOUTNOTICE: 'receivedwithoutnotice',
    REMINDED: 'reminded',
    REPLENISH: 'replenish',
    SENT: 'sent',
    SHIPPED: 'shipped',
    SNOOZE: 'snooze',
    TO_PROCESS: 'to_process',
    UNLINKED: 'unlinked',
    REJECTED: 'rejected',
    ECHECKPAUSED: 'echeckpaused',
    PROCESSED: 'processed',
    HIDDEN: 'hidden',
    RESOLVED: 'resolved',
    CLOSED: 'closed'
};

// Warehouselocationtype
export const warehouselocationtype_type = {
    BULK: 'bulk',
    ECHECK: 'echeck',
    GENERAL: 'general',
    LINK: 'link',
    TEMP: 'temp',
    TRANSITION: 'transition',
    RETURNS: 'returns'
};

// Shipment
export const shipment_type = {
    STANDARD: 'standard',
    MAILBOX: 'mailbox',	
    RETURN: 'return',
    PICKUP: 'pickup'
};

export const counting_strategy_type = {
    PICKING_LOCATIONS: "picking_locations",
    BULK_LOCATIONS: "bulk_locations",
    ALL_LOCATIONS: "all_locations",
    INVENTORY_TURNOVER_RATION: "inventory_turnover_ratio"
}

export const condition_object_type = {
    ORDERFIELD:"orderfield",
    PRODUCTFIELD: "productfield"
}

// How a shipper(profile) surcharge is calculated: a percentage over the shipping line, the price of
// its own invoice product, or that price per started weight unit
export const surcharge_calculation_type = {
    PERCENTAGE: 'percentage',
    FIXED: 'fixed',
    PER_WEIGHT: 'per_weight'
}


export const orderline_type = {
    DEFAULT: 'default',
    VIRTUAL_PRODUCT: 'virtual_product',
    ADD_ON: 'add_on'
};

// Webshopcredentials
export const webshopcredentials_webshop_type = {
    woocommerce: 'woocommerce',
    shopify: 'shopify',
    magento: 'magento',
    lightspeed: 'lightspeed',
    lightspeed_ecom: 'lightspeed_ecom',
    prestashop: 'prestashop',
    opencart: 'opencart',
    bigcommerce: 'bigcommerce',
    virtuemart: 'virtuemart',
    hikashop: 'hikashop',
    ccvshop: 'ccvshop',
    mirakl: 'mirakl',
    bol: 'bol',
    bol_com: 'BOL_COM',
    amazon_nl: 'AMAZON_NL',
    amazon_de: 'AMAZON_DE',
    amazon_fr: 'AMAZON_FR',
    amazon_it: 'AMAZON_IT',
    amazon_es: 'AMAZON_ES',
    amazon_se: 'AMAZON_SE',
    amazon_be: 'AMAZON_BE',
    fonq_prod: 'fonq-prod',
    blokker_prod: 'blokker-prod',
    vidaxl_prod: 'vidaxl-prod',
    kleertjes_prod: 'kleertjes-prod',
    leenbakker_prod: 'leenbakker-prod',
    rueducommerce_prod: 'rueDuCommerce-prod',
    conforama_prod: 'conforama-prod',
    conradb2b_prod: 'conradb2b-prod',
    decathlonbelgium2_prod: 'decathlonbelgium2-prod',
    mediamarkt_prod: 'mediamarkt-prod',
    epc_prod: 'epc-prod',
    obelink_prod: 'obelink-prod',
    inno_prod: 'inno-prod',
    alltricks: 'alltricks',
    brico: 'brico',
    praxis: 'praxis',
    yoox: 'yoox',
    leroymerlin: 'leroymerlin',
    secretsales: 'SecretSales',
    worten: 'worten',
    mdm: 'mdm',
    home24: 'home24',
    vtwonen: 'vtwonen',
    hornbach: 'hornbach',
    eleclerc: 'eleclerc',
    la_poste: 'la-poste',
    anwb: 'ANWB',
    vente_unique: 'vente-unique',
    kruidvat: 'kruidvat',
    shopapotheke: 'shopapotheke',
    kaufland_prod: 'kaufland-prod',
    metromakro: 'MetroMakro',
    picqer: 'picqer',
    lyra: 'lyra',
    bol_nl: 'bol_nl',
    bol_be: 'bol_be',
    amazon_us_v2: 'amazon_us_v2',
    amazon_uk: 'amazon_uk',
    google_manufacturer_en: 'google_manufacturer_en',
    google_manufacturer_nl: 'google_manufacturer_nl',
    ebay_nl: 'ebay_nl',
    beslist_nl: 'beslist_nl',
    vidaxl_en: 'vidaxl_en',
    vidaxl_nl: 'vidaxl_nl',
    vidaxl_de: 'vidaxl_de',
    vidaxl_es: 'vidaxl_es',
    vidaxl_fr: 'vidaxl_fr',
    vidaxl_it: 'vidaxl_it',
    vidaxl_sv: 'vidaxl_sv',
    blokker_nl: 'blokker_nl',
    gartentraeume_de: 'gartentraeume_de',
    real_de: 'real_de',
    fonq_nl: 'fonq_nl',
    ebay_de: 'ebay_de',
    ebay_fr: 'ebay_fr',
    ebay_es: 'ebay_es',
    ebay_it: 'ebay_it',
    ebay_uk: 'ebay_uk',
    ebay_us: 'ebay_us',
    fonq_be: 'fonq_be',
    fnac_fr: 'fnac_fr',
    marktplaats_nl: 'marktplaats-nl',
    vtwonen_nl: 'vtwonen_nl',
    vtwonen_be: 'vtwonen_be',
    vidaxl_be: 'vidaxl_be',
    amazon_sv: 'amazon_sv',
    cdiscount_fr: 'cdiscount_fr',
    bol_fr: 'bol_fr',
    homedeco_nl: 'homedeco_nl',
    knit_factory_nl: 'knit_factory_nl',
    knit_factory_de: 'knit_factory_de',
    knit_factory_en: 'knit_factory_en',
    knit_factory_fr: 'knit_factory_fr',
    knit_factory_es: 'knit_factory_es',
    knit_factory_it: 'knit_factory_it',
    babys_only_nl: 'babys_only_nl',
    babys_only_de: 'babys_only_de',
    babys_only_en: 'babys_only_en',
    babys_only_fr: 'babys_only_fr',
    babys_only_es: 'babys_only_es',
    babys_only_it: 'babys_only_it',
    retour_jeans_nl_oud: 'retour_jeans_nl_oud',
    google_merchant_nl: 'google_merchant_nl',
    facebook_commerce_nl: 'facebook_commerce_nl',
    google_merchant_us: 'google_merchant_us',
    google_merchant_de: 'google_merchant_de',
    google_merchant_fr: 'google_merchant_fr',
    google_merchant_es: 'google_merchant_es',
    google_merchant_it: 'google_merchant_it',
    google_merchant_sv: 'google_merchant_sv',
    facebook_commerce_us: 'facebook_commerce_us',
    facebook_commerce_de: 'facebook_commerce_de',
    facebook_commerce_fr: 'facebook_commerce_fr',
    facebook_commerce_es: 'facebook_commerce_es',
    facebook_commerce_it: 'facebook_commerce_it',
    facebook_commerce_sv: 'facebook_commerce_sv',
    adtraction_nl: 'adtraction_nl',
    naduvi_nl: 'naduvi_nl',
    thuis_in_de_tuin_nl: 'thuis_in_de_tuin_nl',
    amazon_pl: 'amazon_pl',
    fnac_be: 'fnac_be',
    plexidirect_nl: 'plexidirect_nl',
    plexidirect_de: 'plexidirect_de',
    plexidirect_uk: 'plexidirect_uk',
    tuinhaardxxl_nl: 'tuinhaardxxl_nl',
    woocommerce_nl: 'woocommerce_nl',
    google_merchant_uk: 'google_merchant_uk',
    shopware6_nl: 'shopware6_nl',
    lightspeed_nl: 'lightspeed_nl',
    goodz_nl: '4goodz_nl',
    knit_factory_b2c_nl: 'knit_factory_b2c_nl',
    knit_factory_b2c_de: 'knit_factory_b2c_de',
    knit_factory_b2c_en: 'knit_factory_b2c_en',
    knit_factory_b2c_fr: 'knit_factory_b2c_fr',
    knit_factory_b2c_es: 'knit_factory_b2c_es',
    knit_factory_b2c_it: 'knit_factory_b2c_it',
    bbqdirect_nl: 'bbqdirect_nl',
    babys_only_b2c_nl: 'babys_only_b2c_nl',
    babys_only_b2c_de: 'babys_only_b2c_de',
    babys_only_b2c_en: 'babys_only_b2c_en',
    babys_only_b2c_fr: 'babys_only_b2c_fr',
    babys_only_b2c_es: 'babys_only_b2c_es',
    babys_only_b2c_it: 'babys_only_b2c_it',
    vidaxl_cz: 'vidaxl_cz',
    woocommerce_nl_2: 'woocommerce_nl_2',
    lightspeed_nl_2: 'lightspeed_nl_2',
    productflow_nl: 'productflow_nl',
    woocommerce_nl_3: 'woocommerce_nl_3',
    lokaal_ideaal_nl: 'lokaal_ideaal_nl',
    decathlon_nl: 'decathlon_nl',
    kleertjes_nl: 'kleertjes_nl',
    decathlon_be: 'decathlon_be',
    decathlon_fr: 'decathlon_fr',
    care_delta_nl: 'care_delta_nl',
    woocommerce_nl_4: 'woocommerce_nl_4',
    leen_bakker_nl: 'leen_bakker_nl',
    zalando_nl: 'zalando_nl',
    zalando_de: 'zalando_de',
    zalando_fr: 'zalando_fr',
    zalando_it: 'zalando_it',
    zalando_es: 'zalando_es',
    exposupply_de: 'exposupply_de',
    exposupply_nl: 'exposupply_nl',
    exposupply_uk: 'exposupply_uk',
    obelink_nl: 'obelink_nl',
    case2go_nl: 'case2go_nl',
    wintersportstore_nl: 'wintersportstore_nl',
    summersportstore_nl: 'summersportstore_nl',
    cover2day_nl: 'cover2day_nl',
    woodburner_nl: 'woodburner_nl',
    palletranden_nl: 'palletranden_nl',
    bbqshop_limburg_nl: 'bbqshop_limburg_nl',
    decathlon_de: 'decathlon_de',
    decathlon_it: 'decathlon_it',
    decathlon_es: 'decathlon_es',
    decathlon_pl: 'decathlon_pl',
    textieldotcom_nl: 'textieldotcom_nl',
    amazon_tr: 'amazon_tr',
    briesaanzee_nl: 'briesaanzee_nl',
    briesaanzee_de: 'briesaanzee_de',
    briesaanzee_en: 'briesaanzee_en',
    briesaanzee_fr: 'briesaanzee_fr',
    briesaanzee_es: 'briesaanzee_es',
    lokaal_ideaal_stage: 'lokaal_ideaal_stage',
    klik_en_steen_nl: 'klik_en_steen_nl',
    woocommerce_nl_5: 'woocommerce_nl_5',
    woocommerce_nl_6: 'woocommerce_nl_6',
    woocommerce_nl_7: 'woocommerce_nl_7',
    woocommerce_nl_8: 'woocommerce_nl_8',
    back_market_nl: 'back_market_nl',
    back_market_be: 'back_market_be',
    back_market_fr: 'back_market_fr',
    back_market_es: 'back_market_es',
    back_market_de: 'back_market_de',
    back_market_it: 'back_market_it',
    back_market_uk: 'back_market_uk',
    back_market_sv: 'back_market_sv',
    schmiedeeisernebeschlaege: 'schmiedeeisernebeschlaege',
    smeedijzerenbeslag: 'smeedijzerenbeslag',
    back_market_pt: 'back_market_pt',
    back_market_sk: 'back_market_sk',
    back_market_gr: 'back_market_gr',
    leen_bakker_be: 'leen_bakker_be',
    meitrade_nl: 'meitrade_nl',
    klik_en_steen_magento_nl: 'klik_en_steen_magento_nl',
    electrobee_nl: 'electrobee_nl',
    samm_nl: 'samm_nl',
    wintersportstore_de: 'wintersportstore_de',
    wintersportstore_fr: 'wintersportstore_fr',
    wintersportstore_es: 'wintersportstore_es',
    zalando_be: 'zalando_be',
    giga_gaas_nl: 'giga_gaas_nl',
    bintra_nl: 'bintra_nl',
    bintra_en: 'bintra_en',
    decathlon_pt: 'decathlon_pt',
    meitrade_de: 'meitrade_de',
    meitrade_fr: 'meitrade_fr',
    meitrade_it: 'meitrade_it',
    meitrade_es: 'meitrade_es',
    meitrade_en: 'meitrade_en',
    meitrade_pl: 'meitrade_pl',
    meitrade_sv: 'meitrade_sv',
    meitrade_da: 'meitrade_da',
    woodburner_de: 'woodburner_de',
    shopify_nl: 'shopify_nl',
    ledtohave_nl: 'ledtohave_nl',
    wantohave_nl: 'wantohave_nl',
    zalando_fi: 'zalando_fi',
    zalando_lv: 'zalando_lv',
    zalando_ie: 'zalando_ie',
    zalando_sk: 'zalando_sk',
    zalando_si: 'zalando_si',
    zalando_ee: 'zalando_ee',
    zalando_lt: 'zalando_lt',
    exposupply_fr: 'exposupply_fr',
    gloeilicht_nl: 'gloeilicht_nl',
    ergo2go_nl: 'ergo2go_nl',
    degros_nl: 'degros_nl',
    klik_en_steen_shopware_nl: 'klik_en_steen_shopware_nl',
    perfectly_trendy_nl: 'perfectly_trendy_nl',
    soccerconcepts_nl: 'soccerconcepts_nl',
    alarmsysteemexpert_nl: 'alarmsysteemexpert_nl',
    alarmsysteemexpert_de: 'alarmsysteemexpert_de',
    zonfo_nl: 'zonfo_nl',
    dezorgfirma_nl: 'dezorgfirma_nl',
    woodburner_fr: 'woodburner_fr',
    woodburner_se: 'woodburner_se',
    woodburner_it: 'woodburner_it',
    woodburner_es: 'woodburner_es',
    giga_gaas_fr: 'giga_gaas_fr',
    giga_gaas_se: 'giga_gaas_se',
    giga_gaas_it: 'giga_gaas_it',
    giga_gaas_es: 'giga_gaas_es',
    dealdonkey_nl: 'dealdonkey_nl',
    koif_nl: 'koif_nl',
    leen_bakker_fr: 'leen_bakker_fr',
    obelink_de: 'obelink_de',
    nessk_nl: 'nessk_nl',
    jerma: 'jerma',
    zalando_pl: 'zalando_pl',
    bo_shopware_b2c_nl: 'bo_shopware_b2c_nl',
    home24_nl: 'home24_nl',
    retour_jeans_nl: 'retour_jeans_nl',
    giga_gaas_de: 'giga_gaas_de',
    bartogi_nl: 'bartogi_nl',
    actiemarkt_nl: 'actiemarkt_nl',
    actiemarkt_en: 'actiemarkt_en',
    actiemarkt_de: 'actiemarkt_de',
    actiemarkt_fr: 'actiemarkt_fr',
    alarmsysteemexpert_en: 'alarmsysteemexpert_en',
    alarmsysteemexpert_fr: 'alarmsysteemexpert_fr',
    alarmsysteemexpert_pt: 'alarmsysteemexpert_pt',
    alarmsysteemexpert_es: 'alarmsysteemexpert_es',
    alarmsysteemexpert_it: 'alarmsysteemexpert_it',
    kaufland_cz: 'kaufland_cz',
    kaufland_sk: 'kaufland_sk',
    bartogi_de: 'bartogi_de',
    heydude_nl: 'heydude_nl',
    janjansen_nl: 'janjansen_nl',
    janjansen_en: 'janjansen_en',
    lazamani_nl: 'lazamani_nl',
    lomer_nl: 'lomer_nl',
    lomer_de: 'lomer_de',
    sockwell_nl: 'sockwell_nl',
    sockwell_de: 'sockwell_de',
    sockwell_fr: 'sockwell_fr',
    sockwell_es: 'sockwell_es',
    sockwell_it: 'sockwell_it',
    tofvel_nl: 'tofvel_nl',
    tofvel_de: 'tofvel_de',
    tonipons_nl: 'tonipons_nl',
    yachtsupplier_nl: 'yachtsupplier_nl',
    sockwell_eu: 'sockwell_eu',
    tofvel_eu: 'tofvel_eu',
    home24_de: 'home24_de',
    home24_fr: 'home24_fr',
    triple_j_online_nl: 'triple_j_online_nl',
    bladi_shop_nl: 'bladi_shop_nl',
    deal2day_nl: 'deal2day_nl',
    happy_vino_nl: 'happy_vino_nl',
    haarspullen_nl: 'haarspullen_nl',
    refurbed_nl: 'refurbed_nl',
    lampenwereld_nl: 'lampenwereld_nl',
    alarmenlageexperte_de: 'alarmenlageexperte_de',
    praxis_nl: 'praxis_nl',
    brico_be_nl: 'brico_be_nl',
    zalando_bartogi_en: 'zalando_bartogi_en',
    zalando_knit_factory_en: 'zalando_knit_factory_en',
    haarlemsewinkels_nl: 'haarlemsewinkels_nl',
    shopify2_nl: 'shopify2_nl',
    shopify3_nl: 'shopify3_nl',
    hoyz_nl: 'hoyz_nl',
    soccerconcepts_fr: 'soccerconcepts_fr',
    zalando_underwear_district_en: 'zalando_underwear_district_en',
    cdon_sv: 'cdon_sv',
    cdon_da: 'cdon_da',
    cdon_no: 'cdon_no',
    cdon_fi: 'cdon_fi',
    lazamani_de: 'lazamani_de',
    underweardistrict_nl: 'underweardistrict_nl',
    underweardistrict_en: 'underweardistrict_en',
    allyourgames_nl: 'allyourgames_nl',
    easylink_woocommerce_test: 'easylink_woocommerce_test',
    magento2_nl: 'magento2_nl',
    second_best_nl: 'second_best_nl',
    second_best_en: 'second_best_en',
    digits_nl: '7digits_nl',
    digits_en: '7digits_en',
    kappersakademie_nl: 'kappersakademie_nl',
    kappersakademie_en_eu: 'kappersakademie_en_eu',
    kappersakademie_fr: 'kappersakademie_fr',
    kappersakademie_de: 'kappersakademie_de',
    kopu_nl: 'kopu_nl',
    tuinkussenwinkel_nl: 'tuinkussenwinkel_nl',
    haarspullen_en: 'haarspullen_en',
    coquetelephone_fr: 'coquetelephone_fr',
    fundamovil_es: 'fundamovil_es',
    huellenshop_de: 'huellenshop_de',
    phonefactory_nl: 'phonefactory_nl',
    woocommerce_de: 'woocommerce_de',
    woocommerce_fr: 'woocommerce_fr',
    woocommerce_en: 'woocommerce_en',
    lazamani_en: 'lazamani_en',
    amazon_nl_v2: 'amazon_nl_v2',
    galeria_inno_be: 'galeria_inno_be',
    babys_only_b2c_shopware_nl: 'babys_only_b2c_shopware_nl',
    keen_nl: 'keen_nl',
    blisso_nl: 'blisso_nl',
    blisso_de: 'blisso_de',
    blisso_fr: 'blisso_fr',
    blisso_be_fr: 'blisso_be_fr',
    blisso_be_nl: 'blisso_be_nl',
    trendyhoesjes_nl: 'trendyhoesjes_nl',
    trendyhoesjes_en: 'trendyhoesjes_en',
    trendyhoesjes_de: 'trendyhoesjes_de',
    trendyhoesjes_fr: 'trendyhoesjes_fr',
    trendyhoesjes_es: 'trendyhoesjes_es',
    trendyhoesjes_it: 'trendyhoesjes_it',
    allyourgames_en: 'allyourgames_en',
    allyourgames_de: 'allyourgames_de',
    allyourgames_fr: 'allyourgames_fr',
    allyourgames_es: 'allyourgames_es',
    allyourgames_it: 'allyourgames_it',
    powercom_nl: 'powercom_nl',
    powercom_en: 'powercom_en',
    powercom_de: 'powercom_de',
    powercom_fr: 'powercom_fr',
    haarlemsewinkels_dev_nl: 'haarlemsewinkels_dev_nl',
    allyourgames_be: 'allyourgames_be',
    allyourgames_eu_en: 'allyourgames_eu_en',
    bodybow_be: 'bodybow_be',
    amazon_ca_v2: 'amazon_ca_v2',
    amazon_mx_v2: 'amazon_mx_v2',
    babys_only_b2c_shopware_de: 'babys_only_b2c_shopware_de',
    warehousesupply_nl: 'warehousesupply_nl',
    warehousesupply_de: 'warehousesupply_de',
    warehousesupply_fr: 'warehousesupply_fr',
    babys_only_b2c_shopware_fr: 'babys_only_b2c_shopware_fr',
    babys_only_b2c_shopware_en: 'babys_only_b2c_shopware_en',
    braceletsmartwatch_fr: 'braceletsmartwatch_fr',
    correasmartwatch_es: 'correasmartwatch_es',
    smartwatcharmbaender_de: 'smartwatcharmbaender_de',
    smartwatchbanden_nl: 'smartwatchbanden_nl',
    smartwatchstraps_en: 'smartwatchstraps_en',
    amazon_de_v2: 'amazon_de_v2',
    amazon_fr_v2: 'amazon_fr_v2',
    mojogear_nl: 'mojogear_nl',
    brico_be_fr: 'brico_be_fr',
    computest_generic_datamodel_nl: 'computest_generic_datamodel_nl',
    amazon_es_v2: 'amazon_es_v2',
    amazon_it_v2: 'amazon_it_v2',
    amazon_gb_v2: 'amazon_gb_v2',
    amazon_se_v2: 'amazon_se_v2',
    amazon_pl_v2: 'amazon_pl_v2',
    magento2_2_nl: 'magento2_2_nl',
    premed_nl: 'premed_nl',
    bodybow_nl: 'bodybow_nl',
    bodybow_fr: 'bodybow_fr',
    amazon_be_nl_v2: 'amazon_be_nl_v2',
    amazon_be_fr_v2: 'amazon_be_fr_v2',
    amazon_ca_fr_v2: 'amazon_ca_fr_v2',
    amazon_us_es_v2: 'amazon_us_es_v2',
    mojogear_en: 'mojogear_en',
    mojogear_fr: 'mojogear_fr',
    mojogear_de: 'mojogear_de',
    trendyhuellen_de: 'trendyhuellen_de',
    apresskistore_nl: 'apresskistore_nl',
    apresskistore_de: 'apresskistore_de',
    apresskistore_en: 'apresskistore_en',
    home24_at: 'home24_at',
    vervangingsmarkt_nl: 'vervangingsmarkt_nl',
    kerstbomenwinkel_nl: 'kerstbomenwinkel_nl',
    product_pine_nl: 'product_pine_nl',
    best4u_nl: 'best4u_nl',
    best4u_de: 'best4u_de',
    google_merchant_nl_1: 'google_merchant_nl_1',
    google_merchant_nl_2: 'google_merchant_nl_2',
    google_merchant_nl_3: 'google_merchant_nl_3',
    allyourgames_eu_de: 'allyourgames_eu_de',
    shopify4_nl: 'shopify4_nl',
    shopify5_nl: 'shopify5_nl',
    shopify6_nl: 'shopify6_nl',
    amazon_tr_v2: 'amazon_tr_v2',
    maisons_du_monde_de: 'maisons_du_monde_de',
    conrad_de: 'conrad_de',
    conrad_nl: 'conrad_nl',
    swissclean_nl: 'swissclean_nl',
    mediamarkt_de: 'mediamarkt_de',
    mediamarkt_nl: 'mediamarkt_nl',
    mediamarkt_es: 'mediamarkt_es',
    jouwoutlet_nl: 'jouwoutlet_nl',
    mc_stock_trading_nl: 'mc_stock_trading_nl',
    chapp: 'chapp',
    hismith_erotic_trade_bv_nl: 'hismith_erotic_trade_bv_nl',
    hismith_staging_en: 'hismith_staging_en',
    stuntwinkel_nl: 'stuntwinkel_nl',
    parfumdeo_nl: 'parfumdeo_nl',
    hismith_erotic_trade_bv_de: 'hismith_erotic_trade_bv_de',
    hismith_erotic_trade_bv_en: 'hismith_erotic_trade_bv_en',
    hismith_staging_de: 'hismith_staging_de',
    hismith_staging_fr: 'hismith_staging_fr',
    hismith_staging_sp: 'hismith_staging_sp',
    asiasia_nl: 'asiasia_nl',
    diclya_nl: 'diclya_nl',
    diclya_de: 'diclya_de',
    diclya_fr: 'diclya_fr',
    cuberna_nl: 'cuberna_nl',
    product_pine_en: 'product_pine_en',
    cuberna_de: 'cuberna_de',
    meubelbeslagxxl_nl: 'meubelbeslagxxl_nl',
    hismith_staging_nl: 'hismith_staging_nl',
    flimdeal_nl: 'flimdeal_nl',
    ultramar_products_bv_nl: 'ultramar_products_bv_nl',
    ultramar_products_bv_de: 'ultramar_products_bv_de',
    ultramar_products_bv_fr: 'ultramar_products_bv_fr',
    ultramar_products_bv_it: 'ultramar_products_bv_it',
    ultramar_products_bv_en: 'ultramar_products_bv_en',
    ultramar_products_bv_dk: 'ultramar_products_bv_dk',
    ultramar_products_bv_sk: 'ultramar_products_bv_sk',
    kruidvat_nl: 'kruidvat_nl',
    ccv_shop_nl: 'ccv_shop_nl',
    hgmd_nl: 'hgmd_nl',
    talpa_nl: 'talpa_nl',
    talpa_de: 'talpa_de',
    talpa_fr: 'talpa_fr',
    sportdeal_nl: 'sportdeal_nl',
    zalando_hip_and_chic_en: 'zalando_hip_and_chic_en',
    kaufland_pl: 'kaufland_pl',
    kaufland_at: 'kaufland_at',
    shopify_de: 'shopify_de',
    vanberlobooks_nl: 'vanberlobooks_nl',
    productflow_lightspeed_ecom_nl: 'productflow_lightspeed_ecom_nl',
    ihlas_wholesale_nl: 'ihlas_wholesale_nl',
    barbecuewinkel_nl: 'barbecuewinkel_nl',
    campingazonderdelen_nl: 'campingazonderdelen_nl',
    climatewebshop_nl: 'climatewebshop_nl',
    ecodiervoeding_nl: 'ecodiervoeding_nl',
    heinigershop_nl: 'heinigershop_nl',
    lastvan_nl: 'lastvan_nl',
    luchtbedshop_nl: 'luchtbedshop_nl',
    luchtmatraswinkel_nl: 'luchtmatraswinkel_nl',
    marterwinkel_nl: 'marterwinkel_nl',
    opblaasspa_nl: 'opblaasspa_nl',
    tuinmestwinkel_nl: 'tuinmestwinkel_nl',
    zibrowebshop_nl: 'zibrowebshop_nl',
    zwembadstore_nl: 'zwembadstore_nl',
    metalenbed_nl: 'metalenbed_nl',
    shopify_en: 'shopify_en',
    shopify2_en: 'shopify2_en',
    shopify3_en: 'shopify3_en',
    shopify4_en: 'shopify4_en',
    tink_nl: 'tink_nl',
    allegro_pl: 'allegro_pl',
    allegro_cz: 'allegro_cz',
    allegro_sk: 'allegro_sk',
    rotorcraft_watches_en: 'rotorcraft_watches_en',
    urbn22_en: 'urbn22_en',
    furore_en: 'furore_en',
    ledpanelgrosshandel_de: 'ledpanelgrosshandel_de',
    ledpanelgrosshandel_at: 'ledpanelgrosshandel_at',
    ledgroothandel_nl: 'ledgroothandel_nl',
    ledgroothandel_be: 'ledgroothandel_be',
    led123_se: 'led123_se',
    led123_it: '123led_it',
    led24_uk: 'led24_uk',
    led24_nl_nl: 'led24_nl_nl',
    led24_nl_be: 'led24_nl_be',
    led24_fr_fr: 'led24_fr_fr',
    led24_fr_be: 'led24_fr_be',
    led24_fi: 'led24_fi',
    led24_es: 'led24_es',
    led24_dk: 'led24_dk',
    vakantie_veilingen_nl: 'vakantie_veilingen_nl',
    vakantie_veilingen_de: 'vakantie_veilingen_de',
    tink_de: 'tink_de',
    tink_be: 'tink_be',
    vakantie_veilingen_be_nl: 'vakantie_veilingen_be_nl',
    vakantie_veilingen_be_fr: 'vakantie_veilingen_be_fr',
    vakantie_veilingen_fr: 'vakantie_veilingen_fr',
    talpa_be_nl: 'talpa_be_nl',
    talpa_be_fr: 'talpa_be_fr',
    leroy_merlin_fr: 'leroy_merlin_fr',
    leroy_merlin_it: 'leroy_merlin_it',
    leroy_merlin_es: 'leroy_merlin_es',
    leroy_merlin_pt: 'leroy_merlin_pt',
    vtwonen_v2_nl: 'vtwonen_v2_nl',
    de_goedkoopste_outlet_nl: 'de_goedkoopste_outlet_nl',
    topline_haarcosmetica_nl: 'topline_haarcosmetica_nl',
    nancy_hair_beauty_store_nl: 'nancy_hair_beauty_store_nl',
    verminbuster_nl: 'verminbuster_nl',
    mayce_nl: 'mayce_nl',
    woocommerce_de_2: 'woocommerce_de_2',
    makro_nl: 'makro_nl',
    makro_de: 'makro_de',
    makro_es: 'makro_es',
    makro_fr: 'makro_fr',
    makro_it: 'makro_it',
    makro_pt: 'makro_pt',
    hornbach_nl: 'hornbach_nl',
    hornbach_de: 'hornbach_de',
    hornbach_fr: 'hornbach_fr',
    hornbach_cz: 'hornbach_cz',
    hornbach_ro: 'hornbach_ro',
    hornbach_sk: 'hornbach_sk',
    hornbach_se: 'hornbach_se',
    ccv_shop_nl_2: 'ccv_shop_nl_2',
    plugandpay: 'plugandpay',
    'api': 'api'
}

// Kaufland marketplace storefronts (country codes as used by the Kaufland seller API)
export const kaufland_storefronts = [
    { value: 'de', label: 'Germany (de)' },
    { value: 'cz', label: 'Czech Republic (cz)' },
    { value: 'sk', label: 'Slovakia (sk)' },
    { value: 'at', label: 'Austria (at)' },
    { value: 'pl', label: 'Poland (pl)' },
    { value: 'nl', label: 'Netherlands (nl)' },
    { value: 'fr', label: 'France (fr)' },
    { value: 'it', label: 'Italy (it)' },
    { value: 'es', label: 'Spain (es)' }
];

// Mirakl API base URLs of the marketplaces our customers connect to. Marketplaces not
// listed here are connected with a manually entered URL.
export const mirakl_marketplaces = [
    { value: 'https://adeo-marketplace.mirakl.net/api', label: 'ADEO (Leroy Merlin)' },
    { value: 'https://anwbnl-prod.mirakl.net/api', label: 'ANWB' },
    { value: 'https://autodocde-prod.mirakl.net/api', label: 'Autodoc' },
    { value: 'https://carrefourfr.mirakl.net/api', label: 'Carrefour FR' },
    { value: 'https://marketplace-decathlon-eu.mirakl.net/api', label: 'Decathlon' },
    { value: 'https://douglas-prod.mirakl.net/api', label: 'Douglas' },
    { value: 'https://leclerc-prod.mirakl.net/api', label: 'E.Leclerc' },
    { value: 'https://hornbach-mp.mirakl.net/api', label: 'Hornbach' },
    { value: 'https://kruidvatnl-prod.mirakl.net/api', label: 'Kruidvat' },
    { value: 'https://mediahuisnl-prod.mirakl.net/api', label: 'Mediahuis' },
    { value: 'https://mediamarktsaturn.mirakl.net/api', label: 'MediaMarktSaturn' },
    { value: 'https://marketplace-obelink.mirakl.net/api', label: 'Obelink' },
    { value: 'https://maxedanl-prod.mirakl.net/api', label: 'Praxis (Maxeda)' },
    { value: 'https://shopapotheke.mirakl.net/api', label: 'Shop Apotheke' },
];

// Matches on hostname, so saved URLs with a wrong path (…/user/api-key) still resolve
// to their marketplace. Returns -1 for unknown or empty URLs.
export const findMiraklMarketplaceIndex = (url) =>
    url ? mirakl_marketplaces.findIndex(m => m.value.split('/')[2] === url.split('/')[2]) : -1;

export const customer_type = {
    PRODUCTION: 'production',
    TESTING: 'testing',
    DEVELOPMENT: 'development',
    INACTIVE: 'inactive',
    UNKNOWN: 'unknown'
}

export const echeck_scan_option = {
    DEFAULT:"default",
    ALWAYS_SCAN:"always_scan",
    NEVER_SCAN:"never_scan",
}

// Mirrors backend enum.utils.echeck_confirm_product_amount_type.
export const echeck_confirm_product_amount_option = {
    DEFAULT:"default",
    ALWAYS:"always",
    NEVER:"never",
}

// Mirrors backend enum.utils.support_ticket_linked_type.
export const support_ticket_linked_type = {
    ORDER: 'order',
    INBOUND: 'inbound',
    PRODUCT: 'product',
    RETURN: 'return',
    INVOICE: 'invoice',
    WEBSHOPCREDENTIALS: 'webshopcredentials',
    // Ticket-to-ticket — used for follow-ups on closed tickets.
    TICKET: 'ticket',
    OTHER:'other',
};

// Maps a backend linked-type value to its global-search "key" (the plural form
// used as the group key in /search results and as the lookup key in search_keys).
export const support_ticket_linked_type_to_search_key = {
    [support_ticket_linked_type.ORDER]: 'orders',
    [support_ticket_linked_type.INBOUND]: 'inbounds',
    [support_ticket_linked_type.PRODUCT]: 'products',
    [support_ticket_linked_type.RETURN]: 'returns',
    [support_ticket_linked_type.INVOICE]: 'invoices',
    [support_ticket_linked_type.WEBSHOPCREDENTIALS]: 'webshopcredentials',
    [support_ticket_linked_type.TICKET]: 'tickets',
};

// Reverse lookup: search key -> linked type.
export const search_key_to_support_ticket_linked_type = Object.entries(
    support_ticket_linked_type_to_search_key
).reduce((acc, [linked, key]) => {
    acc[key] = linked;
    return acc;
}, {});

// Categorizes what a support ticket is about. Mirrors the linked-type values,
// minus TICKET (which is a link target only — a ticket can't be categorized
// as "about another ticket").
const { TICKET: _excludedTicketType, ...supportTicketTypeValues } = support_ticket_linked_type;
export const support_ticket_type = supportTicketTypeValues;


// Support ticket activity actions
export const support_ticket_activity_action = {
    CREATED: 'created',
    STATUS_CHANGED: 'status_changed',
    PRIORITY_CHANGED: 'priority_changed',
    ASSIGNED: 'assigned',
    UNASSIGNED: 'unassigned',
    LABEL_ADDED: 'label_added',
    LABEL_REMOVED: 'label_removed',
    LINKED_ITEM_ADDED: 'linked_item_added',
    LINKED_ITEM_REMOVED: 'linked_item_removed',
    MESSAGE_ADDED: 'message_added',
    ATTACHMENT_ADDED: 'attachment_added',
    ATTACHMENT_REMOVED: 'attachment_removed'
};

// Support ticket lifecycle status. Mirrors backend enum.utils.support_ticket_status.
// Whose-turn ("waiting on customer/warehouse") is derived from the last
// non-internal message sender — see the dashboard responsibility query.
export const support_ticket_status = {
    OPEN: 'open',
    IN_PROGRESS: 'in_progress',
    RESOLVED: 'resolved',
    CLOSED: 'closed'
};

// Support ticket priority. Mirrors backend enum.utils.support_ticket_priority.
export const support_ticket_priority = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent'
};

// Mode for the automatic best-before (THT) quarantine setting on a product.
// Mirrors backend enum.utils.bbdate_quarantine_mode.
export const bbdate_quarantine_mode = {
    EXPIRED: 'expired',
    WITHIN_DAYS: 'within_days'
};

// An invoiceproduct is stored as a type + subType pair, but neither value means much on
// its own to the person picking it. Every pair the warehouse actually bills is named once
// here and offered as a single selectable type; picking one writes both fields.
// `color` is the ShLabel variant the pair is shown with. The backend keeps the same pairs with
// their nl label in invoiceproduct_types (app/utils/enum.utils.js) for the tarieven import.
export const invoiceproduct_types = [
    { key: 'invoiceproducttype_order_shipping',          type: 'process_order',            subType: 'order_processing',        color: 'pink' },
    { key: 'invoiceproducttype_pick_and_pack',           type: 'default',                  subType: 'order_processing',        color: 'pink' },
    { key: 'invoiceproducttype_return_credit_payment',   type: 'return_payment',           subType: 'return_payment',          color: 'red' },
    { key: 'invoiceproducttype_return_shipment',         type: 'process_return',           subType: 'return_processing',       color: 'lightblue' },
    { key: 'invoiceproducttype_return_handling',         type: 'default',                  subType: 'return_processing',       color: 'lightblue' },
    { key: 'invoiceproducttype_return_transaction_cost', type: 'return_transaction_cost',  subType: 'return_transaction_cost', color: 'yellow' },
    { key: 'invoiceproducttype_shipping_material',       type: 'material',                 subType: 'echeck',                  color: 'orange' },
    { key: 'invoiceproducttype_surcharges',              type: 'default',                  subType: 'surcharges',              color: 'brown' },
    { key: 'invoiceproducttype_amazon_monthly',          type: 'amazon',                   subType: 'monthly',                 color: 'purple' },
    { key: 'invoiceproducttype_amazon_per_order',        type: 'amazon',                   subType: 'order',                   color: 'purple' },
    { key: 'invoiceproducttype_checkout_monthly',        type: 'checkout',                 subType: 'monthly',                 color: 'purple' },
    { key: 'invoiceproducttype_prediko_monthly',         type: 'prediko',                  subType: 'monthly',                 color: 'purple' },
    { key: 'invoiceproducttype_general',                 type: 'default',                  subType: 'general',                 color: 'grey' },
    { key: 'invoiceproducttype_adjustment_charges',      type: 'default',                  subType: 'adjustment_charges',      color: 'brown' },
    { key: 'invoiceproducttype_inbound',                 type: 'default',                  subType: 'inbound',                 color: 'green' },
    { key: 'invoiceproducttype_inbound_processing',      type: 'default',                  subType: 'inbound_processing',      color: 'green' },
    { key: 'invoiceproducttype_fuel_surcharge',          type: 'fuel_surcharges',          subType: 'fuel_surcharges',         color: 'brown' },
    { key: 'invoiceproducttype_customs_fee',             type: 'customs_advance_fee',      subType: 'surcharges',              color: 'brown' }
];

// The named type for a stored pair, or undefined for a pair that predates this list.
export const getInvoiceProductType = (type, subType) =>
    invoiceproduct_types.find(item => item.type === type && item.subType === subType);

// Identifies a pair in the dropdown. An unnamed pair keeps an identity of its own so it
// stays selectable instead of collapsing onto one of the named options. A product without
// a type yet resolves to the dropdowns' empty-selection sentinel.
export const getInvoiceProductTypeKey = (type, subType) => {
    if (!type) return -1;

    return getInvoiceProductType(type, subType)?.key ?? `${type}:${subType}`;
};

// Label for a stored pair: the named type when there is one, otherwise the raw values so
// an older product still shows what it is.
export const getInvoiceProductTypeLabel = (t, type, subType) => {
    const named = getInvoiceProductType(type, subType);
    if (named) return t(named.key);

    return [type, subType].filter(Boolean).map(value => t(value)).join(' - ');
};

// Options for the type dropdown, alphabetical on the translated label so the order follows
// the language. `current` is the pair stored on the product being edited: an unnamed pair is
// appended so editing another field does not silently rewrite it.
export const getInvoiceProductTypeOptions = (t, current) => {
    const options = invoiceproduct_types.map(item => ({ ...item, displayName: t(item.key) }));

    if (current?.type && !getInvoiceProductType(current.type, current.subType)) {
        options.push({
            key: getInvoiceProductTypeKey(current.type, current.subType),
            type: current.type,
            subType: current.subType,
            color: 'grey',
            displayName: getInvoiceProductTypeLabel(t, current.type, current.subType)
        });
    }

    return options.sort((a, b) => a.displayName.localeCompare(b.displayName));
};

// Distance class of a warehouse location to the packstation, 1 is closest and 3 is furthest,
// matching the A, B and C labels of the ABC pick analysis. The first option clears the value.
export const packstationZoneRangeOptions = (t) => [
    { id: null, name: t("not_set") },
    ...[1, 2, 3].map((range) => ({ id: range, name: `${range}` }))
];
